export const indicatorTypes = {
    read: "[Indicator] read",
    clean: "[Indicator] clean",

    // add: "[Indicator] add",
    // edit: "[Indicator] edit",
    // delete: "[Indicator] delete",
};
